import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=71038b69&scoped=true"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=71038b69&prod&lang=css"
import style1 from "./EditQuestion.vue?vue&type=style&index=1&id=71038b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71038b69",
  null
  
)

export default component.exports